import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import commonPropTypes from '../../../constants/commonPropTypes';
import React, { Component, useState, useEffect } from 'react';
import { Form, Placeholder } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classnames from 'classnames/bind';
import FieldError from './fieldError';
import FieldTooltip from './fieldTooltip';
import StandardFieldLabel from './standardFieldLabel';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const FIELD_PLACEHOLDER_LENGTHS = {
    SHORT: 'short',
    MEDIUM: 'medium',
    LONG: 'long',
    FULL: 'full',
};
class RenderEditMode extends Component {
    static propTypes = {
        render: PropTypes.func.isRequired,
        fieldProps: PropTypes.object.isRequired,
    };
    constructor(props) {
        super(props);
        this.state = {
            fieldFocused: false,
        };
    }
    render() {
        const { render, fieldProps: { touched, error, warning, label, checkboxLabel, helpContent, breakAll, hideLabel, hideWrapper, showTooltip, compact, relaxed, onFocus, onBlur, className, elmId, required, input, pendingApproval, disabled, footer: Footer, isLoading, loadingPlaceholderLength, labelOnTop, borderBottom, normalFont, tooltipIconStyle, ...restProps }, } = this.props;
        const { fieldFocused } = this.state;
        const showError = !!(touched && error);
        const showErrorAbove = showError && compact;
        const showErrorBelow = showError && !compact;
        const showAnchor = showTooltip || Boolean(helpContent);
        const isCheckbox = _.has(restProps, 'checked') || _.has(restProps, 'isChecked');
        const onFocusNew = e => {
            this.setState({ fieldFocused: true });
            onFocus && onFocus(e);
        };
        const onBlurNew = e => {
            this.setState({ fieldFocused: false });
            onBlur && onBlur(e);
        };
        const newDisabled = disabled || pendingApproval;
        const labelProps = {
            compact,
            hideLabel,
            showAnchor,
            showErrorAbove,
            helpContent,
            error,
            warning,
            className,
            elmId,
            inputName: input?.name,
            required,
            fieldFocused,
            pendingApproval,
            tooltipIconStyle,
        };
        if (restProps.subLabel) {
            labelProps.subLabel = restProps.subLabel;
        }
        const checkboxLabelProps = {
            label,
            checkboxLabel,
            showAnchor,
            helpContent,
            pendingApproval,
        };
        return (_jsxs(Form.Field, { error: showError, className: cx('field', { compact }, { relaxed }), children: [!isCheckbox &&
                    !hideWrapper &&
                    (!hideLabel || showAnchor) &&
                    StandardFieldLabel.createFromLabel(label, labelProps), render({
                    ...restProps,
                    disabled: newDisabled,
                    onFocus: onFocusNew,
                    onBlur: onBlurNew,
                    compact,
                    className,
                    elmId,
                    required,
                    ...(input ? { input, focus: this.state.fieldFocused } : {}),
                    ...(isCheckbox ? checkboxLabelProps : {}),
                }, showError), !hideWrapper && showErrorBelow && (_jsx(FieldError, { error: error, className: className, elmId: elmId, disabled: newDisabled, ...restProps })), Footer && _jsx(Footer, {})] }));
    }
}
const getViewModeValue = fieldProps => {
    const { value, inputLabel, type, checked } = fieldProps;
    const isCheckbox = _.has(fieldProps, 'checked');
    let result = '';
    if (fieldProps.options) {
        if (_.isArray(value)) {
            const options = _.map(value, val => {
                const option = _.find(fieldProps.options, { value: val });
                return option ? option.text : '';
            });
            result = options ? options.join(', ') : '';
        }
        else {
            const option = _.find(fieldProps.options, { value });
            result = option ? option.text : '';
        }
    }
    else if (_.isObject(value) && value.selectedAddressText) {
        result = value.selectedAddressText;
    }
    else if (type === 'password') {
        result = '●'.repeat(value.length);
    }
    else if (isCheckbox) {
        result = checked ? 'Yes' : 'No';
    }
    else {
        const finalValue = _.isBoolean(value) ? String(value) : value;
        result = result.replace(/\r/g, '<br>');
        result = finalValue ? `${inputLabel || ''}${finalValue || ''}` : '';
    }
    return result;
};
const renderValue = (value, componentName) => {
    if (componentName === 'RichTextField') {
        return _jsx("span", { dangerouslySetInnerHTML: { __html: value } });
    }
    if (typeof value === 'string' && value.indexOf('\n') !== -1) {
        return value.split('\n').map((item, key) => {
            return (_jsxs("span", { children: [item, _jsx("br", {})] }, key));
        });
    }
    return value || _jsx("span", { children: '\u00a0' });
};
const LENGTHS = {
    FULL: 'full',
    VERY_LONG: 'very long',
    LONG: 'long',
    MEDIUM: 'medium',
    SHORT: 'short',
    VERY_SHORT: 'very short',
};
const getPlaceholderLength = (lengthRequested = FIELD_PLACEHOLDER_LENGTHS.MEDIUM, isMounted) => {
    if (!isMounted) {
        return lengthRequested;
    }
    const getRand = () => [Math.floor(Math.random() * 3)];
    let resultLength;
    switch (lengthRequested) {
        case FIELD_PLACEHOLDER_LENGTHS.FULL:
            resultLength = LENGTHS.FULL;
            break;
        case FIELD_PLACEHOLDER_LENGTHS.SHORT:
            resultLength = [LENGTHS.VERY_SHORT, LENGTHS.SHORT, LENGTHS.MEDIUM][getRand()];
            break;
        case FIELD_PLACEHOLDER_LENGTHS.LONG:
            resultLength = [LENGTHS.MEDIUM, LENGTHS.LONG, LENGTHS.VERY_LONG][getRand()];
            break;
        default:
            resultLength = [LENGTHS.SHORT, LENGTHS.MEDIUM, LENGTHS.LONG][getRand()];
            break;
    }
    return resultLength;
};
const renderViewMode = (viewModeRenderer, fieldProps) => {
    const [isMounted, setIsMounted] = useState(false);
    useEffect(() => {
        setIsMounted(true);
    });
    const { elmId, label, helpContent, breakAll, hideWrapper, hideLabel, labelOnTop = true, borderBottom, normalFont = false, showTooltip, compact, isLoading, loadingPlaceholderLength, componentName, tooltipIconStyle, } = fieldProps;
    const value = getViewModeValue(fieldProps);
    const showAnchor = showTooltip;
    const content = viewModeRenderer
        ? viewModeRenderer(fieldProps.value)
        : renderValue(value, componentName);
    return (_jsxs("div", { className: cx('view', { compact }, { 'horizontal-layout': !labelOnTop }, { 'normal-font': normalFont }, { 'border-default': !borderBottom }, { 'border-bottom-always': borderBottom === 'always' }, { 'border-bottom-none': borderBottom === 'none' }, { 'border-bottom-small-screens': borderBottom === 'smallScreensOnly' }), children: [!hideWrapper && !hideLabel && (_jsx("div", { "data-elm-id": `${elmId}_label`, className: cx('label'), children: label })), _jsx("div", { "data-elm-id": `${elmId}_value`, className: cx('value', { 'break-all': breakAll }), children: isLoading ? (_jsx(Placeholder, { className: cx('loading-placeholder'), children: _jsx(Placeholder.Line, { length: getPlaceholderLength(loadingPlaceholderLength, isMounted) }) })) : (content) }), !hideWrapper && showAnchor && (_jsx("div", { className: cx('tooltip'), children: _jsx(FieldTooltip, { helpContent: helpContent, iconStyle: tooltipIconStyle, ...fieldProps }) }))] }));
};
export const formFieldWrapper = render => fieldProps => {
    const { viewMode, viewModeRenderer, ...restProps } = fieldProps;
    return viewMode ? (renderViewMode(viewModeRenderer, restProps)) : (_jsx(RenderEditMode, { render: render, fieldProps: restProps }));
};
export { commonPropTypes, getViewModeValue, FIELD_PLACEHOLDER_LENGTHS };
//# sourceMappingURL=index.js.map